import styled from 'styled-components';
import { devices } from '@/constants/media';

export const StyledToggleButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-xs);
  font-family: var(--font-family-base);
  font-weight: 600;
  border-radius: 50%;
  height: 48px;
  width: 48px;
  padding: var(--spacing-xs);
  font-size: var(--font-size-sm);
  background-color: var(--color-toggle-bg);
  color: var(--color-white);
  border: none;
  transition: all var(--transition-fast);
  cursor: pointer;
  outline: none;

  svg {
    width: 24px;
    height: 24px;
  }

  span {
    font-size: 0.7rem;
    margin-top: 2px;
  }

  &:active {
    transform: scale(0.95);
  }

  &:disabled {
    transform: scale(1);
    cursor: not-allowed;
    opacity: 0.8;
  }

  @media ${devices.sm} {
    height: 40px;
    width: 40px;
    svg {
      width: 20px;
      height: 20px;
    }
  }
`;